<template>
	<div>
		<v-bottom-sheet v-model="sheet">
			<v-list class="pb-0">
				<v-list-tile
				@click="launchFilePicker('camera')">
					<v-list-tile-avatar>
						<v-avatar size="32px" tile>
							<v-icon>camera</v-icon>
						</v-avatar>
					</v-list-tile-avatar>
					<v-list-tile-title>CAMERA</v-list-tile-title>
				</v-list-tile>
				<v-list-tile
					@click="launchFilePicker('library')">
					<v-list-tile-avatar>
						<v-avatar size="32px" tile>
							<v-icon>image</v-icon>
						</v-avatar>
					</v-list-tile-avatar>
					<v-list-tile-title>GALLERIA</v-list-tile-title>
				</v-list-tile>
				<v-divider></v-divider>
				<v-list-tile
					class="red white--text"
					@click="sheet = false">
					<v-list-tile-avatar>
						<v-avatar size="32px" tile>
							<v-icon color="white">close</v-icon>
						</v-avatar>
					</v-list-tile-avatar>
					<v-list-tile-title>CHIUDI</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-bottom-sheet>

		<!-- slot for parent component to activate the file changer -->
		<div @click="clickAvatar()">
			<slot name="activator"></slot>
		</div>
		<!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
		<input type="file"
			accept="image/*"
			capture
			ref="file"
			@change="getBase64($event.target.files[0])"
			style="display:none">
			<!-- error dialog displays any potential error messages -->
			<v-dialog v-model="errorDialog" max-width="300">
				<v-card>
					<v-card-text class="subheading">{{errorText}}</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="errorDialog = false" flat>OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		<div id="canvas"></div>
	</div>
</template>

<script>
export default {
	name: 'image-input',
	data() {
		return {
			errorDialog: null,
			errorText: '',
			sheet: false
		}
	},

	props: {
		value: String
	},

	methods: {
		clickAvatar() {
			if (typeof cordova == 'object') {
				this.sheet = true
			} else {
				this.$refs.file.click()
			}
		},
		launchFilePicker(source) {
			this.sheet = false
			let sourceType = ''
			if (source == 'camera') sourceType = Camera.PictureSourceType.CAMERA
			else if (source == 'library')
				sourceType = Camera.PictureSourceType.PHOTOLIBRARY
			else return false

			navigator.camera.getPicture(response => {
				this.optimizeDataURL('data:image/png;base64,' + response)
			},
			error => {
				this.errorText = error
				this.errorDialog = true
			},
			{
				quality: 20,
				destinationType: Camera.DestinationType.DATA_URL,
				sourceType: sourceType,
				allowEdit: true
			})
		},
		getBase64(file) {
			let dataurl = null

			// Create a file reader
			let reader = new FileReader()
			// Set the image once loaded into file reader
			reader.onload = e => {
				this.optimizeDataURL(e.target.result)
			}
			// Load files into file reader
			reader.readAsDataURL(file)
		},

		optimizeDataURL(data) {
			let img = document.createElement('img')
			img.src = data

			img.onload = () => {
				let canvas = document.createElement('canvas')
				let ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0)

				let MAX_WIDTH = 150
				let MAX_HEIGHT = 150
				let width = img.width
				let height = img.height

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width
						width = MAX_WIDTH
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height
						height = MAX_HEIGHT
					}
				}
				canvas.width = width
				canvas.height = height
				ctx.drawImage(img, 0, 0, width, height)

				let dataurl = canvas.toDataURL('image/jpeg')

				this.$emit('input', dataurl)
			}
		}
	}
}
</script>
